<template>
  <div id="cyry">
    <div v-for="item in list">
      <p><b>{{item.XM}}</b></p>
      <p>
        {{item.XB}}，{{item.CYZGH}}，{{item.RZBM}}{{item.ZW}}，{{item.RXZSJ}}任现职
        <span v-for="jl in item.XGJL" v-if="jl.title!=='无'">；&nbsp{{jl.title}}{{jl.text}}</span>
        。
      </p>
      <div class="margin-b"></div>
    </div>
  </div>
</template>

<script>
  import ajax from '@/common/ajax/ajax'
  export default {
    name: 'cyry',
    data () {
      return {
        list: [{xm: '数据读取中'}]
      }
    },
    created: function () {
      ajax.getCyry().then(
        data => {
          this.list = data
        }
      )
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// cyry.vue?7667a481